import { lazyInject } from '../../../../../services/inversify';
import * as React from 'react';
import DialogWrapper2 from '../../../../../core/dialog/dialog_wrapper_v2';
import { WActionButton } from '../../../../../core/elements/WActionButton';
import { IDs } from '../../../../../helpers/IDs';
import { DialogOelBerechnung } from '../../../dialogs/DialogOelBerechnung';
import { TriggerService } from '../../../../../core/trigger/trigger_service';

export interface OelButtonWrapperProps {
    data: any;
    values: any;
    jahr: number;
    standortSelected: any;
    callback: (data: any) => void;
}

export interface OelButtonWrapperState {
    dataForOptionalDialog: any;
}

export class OelButtonWrapper extends React.Component<OelButtonWrapperProps, OelButtonWrapperState> {

    constructor(props: any) {
        super(props);
        this.state = {
            dataForOptionalDialog: undefined,
        };
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    private buttonOnAction: any;

    componentWillUnmount(): void {
        if (this.buttonOnAction) {
            this.triggerService.unregister('onAction', 'OelButtonWrapper', this.buttonOnAction);
        }
    }

    render(): JSX.Element {
        const { dataForOptionalDialog } = this.state;
        const { standortSelected, jahr, values } = this.props;

        if (!values) {
            return <span></span>;
        }

        const onClose = () => {
            this.setState({ dataForOptionalDialog: undefined });
        };

        const title = dataForOptionalDialog ? `Standort: ${dataForOptionalDialog.standortSelected.name}` : '';

        return (
            <div style={{ marginTop: -10, marginBottom: 20 }}>
                <WActionButton
                    label='Brennstoff-Verbräuche'
                    insideText='Brennstoff-Verbräuche'
                    tooltip='Brennstoff-Verbräuche bearbeiten'
                    key='brennstoff-verbraeuche'
                    action='calculator'
                    onAction={() => {
                        const energietraeger_tid = typeof values.energietraeger_tid_orig === 'number' ? values.energietraeger_tid_orig : values.energietraeger_tid;
                        const einheit_tid = typeof values.einheit_tid_orig === 'number' ? values.einheit_tid_orig : values.einheit_tid;
                        const dataForDialog = {
                            standortSelected,
                            entity: { entity: IDs.ENT_ENERGIEDATEN_WAERME },
                            jahr,
                            values,
                            einheit_tid_orig: einheit_tid,
                            energietraeger_tid_orig: energietraeger_tid
                        };
                        this.setState({ dataForOptionalDialog: dataForDialog });
                    }}
                    ref={(button: any) => {
                        if (button && !this.buttonOnAction) {
                            // Siehe auch onFormChangeWaermeAutoOpenDialog
                            this.buttonOnAction = button.props.onAction;
                            this.triggerService.register('onAction', 'OelButtonWrapper', this.buttonOnAction);
                        }
                    }}
                />
                {dataForOptionalDialog &&
                    <div>
                        <DialogWrapper2
                            title={title}
                            width={-1}
                            onAfterClose={onClose}
                        >
                            <DialogOelBerechnung
                                data={this.props.data}
                                standortSelected={dataForOptionalDialog.standortSelected}
                                jahr={dataForOptionalDialog.jahr}
                                values={dataForOptionalDialog.values}
                                einheit={dataForOptionalDialog.einheit_tid_orig}
                                energietraeger={dataForOptionalDialog.energietraeger_tid_orig}
                                onClose={onClose}
                                onTake={(verbrauch: number, kosten: number) => {
                                    const vals = dataForOptionalDialog.values;
                                    vals.verbrauch = verbrauch;
                                    vals.kosten = kosten;
                                    this.props.callback(vals);
                                    onClose();
                                }}
                            />
                        </DialogWrapper2>
                    </div>
                }
            </div>
        );
    }
}
